import { Carousel } from 'antd';
import React, { useRef } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { STATIC_RESOURCE } from '../../../../origin';
import { greens_config, fruit_config } from '../const';
import { chunk } from '../../util';
import './index.less';
import { classify_list } from '../../const';
import { useHistory } from 'react-router-dom';


const contentStyle = {
  margin: 0,
  color: '#fff',
  textAlign: 'center',
};

export default function Index(props) {
  const history = useHistory();
  const { type = '1' } = props;
  const list = chunk(type === '1' ? greens_config : fruit_config, 7);

  const carouselRef = useRef();
  const left = () => carouselRef.current.prev();
  const right = () => carouselRef.current.next();
  const toSearch = (item) => {
    history.push(`/basic/home/${item.zh_title}/1`);
  };
  return (
    <>
      {
        <div className='carousel-container' style={{ background: props.bg }}>
          <div className='carousel-container-left'>
            <div className='carousel-container-left-container'>
              <img src={`${STATIC_RESOURCE}/cp_purchase/index/location${type}.png`} alt='' />
              <div className='carousel-container-left-container-mask'>
                <div className='carousel-container-left-container-mask-text' style={{ background: props.textBg }}>{type === '1' ? classify_list[1][`${props.language || 'zh_'}title`] : classify_list[0][`${props.language || 'zh_'}title`]}</div>
              </div>
            </div>
          </div>
          <LeftOutlined className='carousel-btn' onClick={() => left()} />
          <div className='carousel-container-right'>
            <Carousel dots={false} ref={carouselRef}>
              {
                list.map((item, index) => {
                  return <div key={index}>
                    <div style={contentStyle} className='carousel-container-right-content'>
                      {item.map((subItem, subIndex) => {
                        return <div className='carousel-container-right-item' key={subIndex} onClick={() => toSearch(subItem)}>
                          <img key={subIndex} src={`${STATIC_RESOURCE}/cp_purchase/index/${subItem.en_title}.png`} alt={subItem.title} />
                          <div className='carousel-container-right-item-title'>{subItem[`${props.language || 'zh_'}title`]}</div>
                        </div>;
                      })}
                    </div>
                  </div>;
                })
              }
            </Carousel>
          </div>
          <RightOutlined className='carousel-btn' onClick={() => right()} />
        </div>
      }
    </>
  );
}
